import api from './api';

export const leadTrackingService = {
  // Get all lead tracking records
  getAllLeadTracking: async (params = {}) => {
    try {
      const response = await api.get('/lead-tracking', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting lead tracking records:', error);
      throw error;
    }
  },

  // Get lead tracking by ID
  getLeadTrackingById: async (id) => {
    try {
      const response = await api.get(`/lead-tracking/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting lead tracking record:', error);
      throw error;
    }
  },

  // Create new lead tracking record
  createLeadTracking: async (trackingData) => {
    try {
      const response = await api.post('/lead-tracking', trackingData);
      return response.data;
    } catch (error) {
      console.error('Error creating lead tracking record:', error);
      throw error;
    }
  },

  // Update lead tracking record
  updateLeadTracking: async (id, trackingData) => {
    try {
      const response = await api.put(`/lead-tracking/${id}`, trackingData);
      return response.data;
    } catch (error) {
      console.error('Error updating lead tracking record:', error);
      throw error;
    }
  },

  // Delete lead tracking record
  deleteLeadTracking: async (id) => {
    try {
      const response = await api.delete(`/lead-tracking/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting lead tracking record:', error);
      throw error;
    }
  },

  // Bulk delete lead tracking records
  bulkDeleteLeadTracking: async (trackingIds) => {
    try {
      const response = await api.delete('/lead-tracking/bulk', {
        data: { trackingIds }
      });
      return response.data;
    } catch (error) {
      console.error('Error bulk deleting lead tracking records:', error);
      throw error;
    }
  },

  // Get lead tracking statistics
  getLeadTrackingStats: async () => {
    try {
      const response = await api.get('/lead-tracking/stats/overview');
      return response.data;
    } catch (error) {
      console.error('Error getting lead tracking stats:', error);
      throw error;
    }
  },

  // Get tracking records by lead
  getTrackingByLead: async (leadId) => {
    try {
      const response = await api.get(`/lead-tracking/lead/${leadId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting tracking by lead:', error);
      throw error;
    }
  },

  // Get tracking records by type
  getTrackingByType: async (type) => {
    try {
      const response = await api.get(`/lead-tracking/type/${type}`);
      return response.data;
    } catch (error) {
      console.error('Error getting tracking by type:', error);
      throw error;
    }
  },

  // Get tracking records by status
  getTrackingByStatus: async (status) => {
    try {
      const response = await api.get(`/lead-tracking/status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error getting tracking by status:', error);
      throw error;
    }
  },

  // Get tracking records by assigned user
  getTrackingByAssignedUser: async (userId) => {
    try {
      const response = await api.get(`/lead-tracking/assigned/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting tracking by assigned user:', error);
      throw error;
    }
  },

  // Get pending follow-ups
  getPendingFollowUps: async () => {
    try {
      const response = await api.get('/lead-tracking/follow-ups/pending');
      return response.data;
    } catch (error) {
      console.error('Error getting pending follow-ups:', error);
      throw error;
    }
  }
};
